import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { LoginComponent } from '../pages/login/login.component';
import { asyncForEach } from "../helpers/asyncForEach";
import { localStorageToJsonAsync } from "../helpers/cookieToJson";
import { addAlert } from "../layouts/pages/pages.component";
import { getLanguageCookie } from "../../assets/language";
import { CookieService } from "ngx-cookie-service";
import { to64decode } from '../helpers/base64';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private cookieService: CookieService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      // Permite acesso à rota de password sem autenticação
      if (state.url.startsWith('/password/')) {
        return true;
      }

      const token = localStorage.getItem('token');
      
      if (!token) {
        await this.router.navigate(['/login']);
        return false;
      }

      const response = await this.authService.authExpired();

      if (!response || !response.token) {
        await this.router.navigate(['/login']);
        return false;
      }

      const properties = await localStorageToJsonAsync();
      let flag = false;

      if (state.url === '/' || JSON.parse(to64decode(localStorage.getItem('me')).is_admin_master)) {
        return true;
      }

      if (properties.profile?.permissions) {
        let screens: any = JSON.parse(properties.profile.permissions);
        screens.forEach((screen: any) => {
          if (`/${screen.screen}` === state.url) {
            flag = true;
          }
        });
      }

      if (!flag) {
        addAlert('danger', `${getLanguageCookie('without_permission', localStorage.getItem('language'))}`);
        await this.router.navigate(['/']);
        return false;
      }

      return true;
    } catch (error) {
      await this.router.navigate(['/login']);
      return false;
    }
  }
}




